import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import React from 'react';
import { toast, ToastBar, Toaster } from 'react-hot-toast';

export default function ToasterProvider() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{ top: '120px' }}
      toastOptions={{
        duration: 5000,
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <IconButton
                  size="small"
                  onClick={() => toast.dismiss(t.id)}
                  sx={{ color: 'inherit' }}
                >
                  <CloseIcon fontSize="small" color="inherit" />
                </IconButton>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}
